// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationModal_modal__jqpr1 .modal-dialog {
  max-width: 1250px !important;
  width: 92vw !important;
  margin: 1.75rem auto;
}

.LocationModal_modal__jqpr1 .modal-content {
  max-height: 92vh;
  border-radius: 16px;
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.LocationModal_modal__jqpr1 .modal-body {
  padding: 0px 35px 25px 35px !important;
  overflow-y: auto;
}

.LocationModal_header__3KenT {
  padding: 30px 35px 15px 35px !important;
  background-color: var(--white-color) !important;
  border: none;
}

.LocationModal_heading__RGmg6 {
  color: var(--black-dark-text-color) !important;
  font-size: 22px !important;
  font-weight: 700 !important;
}

.LocationModal_mainDiv__zXegW {
  width: 100%;
}

.LocationModal_leftColumn__QopJO {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.LocationModal_rightColumn__iV-SS {
  display: flex;
  flex-direction: column;
}

.LocationModal_rightColumn__iV-SS .quill {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.LocationModal_rightColumn__iV-SS .ql-container {
  flex: 1 1;
  min-height: 380px !important;
  max-height: 440px;
}

.LocationModal_buttonDiv__q5pvq {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid rgba(142, 142, 142, 0.15);
}

.LocationModal_uploadImageContainerClass__dc2Hh {
  width: 120px;
  height: 90px !important;
  background: var(--white-color-v1);
  border: 2px solid rgba(142, 142, 142, 0.45);
  border-radius: 7px;
}

.LocationModal_uploadRow__gWUGV {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.LocationModal_dropDownContainer__IyPwt > div > div > div {
  padding-left: 10px;
}

.LocationModal_myLabel__7REcE {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 6px;
}

.LocationModal_sectionDivider__S4xOC {
  font-size: 14px;
  font-weight: 700;
  color: var(--primary-color, #15803d);
  margin-top: 4px;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(142, 142, 142, 0.2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/LocationModal/LocationModal.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".modal :global(.modal-dialog) {\n  max-width: 1250px !important;\n  width: 92vw !important;\n  margin: 1.75rem auto;\n}\n\n.modal :global(.modal-content) {\n  max-height: 92vh;\n  border-radius: 16px;\n  position: relative;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal :global(.modal-body) {\n  padding: 0px 35px 25px 35px !important;\n  overflow-y: auto;\n}\n\n.header {\n  padding: 30px 35px 15px 35px !important;\n  background-color: var(--white-color) !important;\n  border: none;\n}\n\n.heading {\n  color: var(--black-dark-text-color) !important;\n  font-size: 22px !important;\n  font-weight: 700 !important;\n}\n\n.mainDiv {\n  width: 100%;\n}\n\n.leftColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.rightColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.rightColumn :global(.quill) {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.rightColumn :global(.ql-container) {\n  flex: 1;\n  min-height: 380px !important;\n  max-height: 440px;\n}\n\n.buttonDiv {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(142, 142, 142, 0.15);\n}\n\n.uploadImageContainerClass {\n  width: 120px;\n  height: 90px !important;\n  background: var(--white-color-v1);\n  border: 2px solid rgba(142, 142, 142, 0.45);\n  border-radius: 7px;\n}\n\n.uploadRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.dropDownContainer > div > div > div {\n  padding-left: 10px;\n}\n\n.myLabel {\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.sectionDivider {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--primary-color, #15803d);\n  margin-top: 4px;\n  margin-bottom: 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid rgba(142, 142, 142, 0.2);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `LocationModal_modal__jqpr1`,
	"header": `LocationModal_header__3KenT`,
	"heading": `LocationModal_heading__RGmg6`,
	"mainDiv": `LocationModal_mainDiv__zXegW`,
	"leftColumn": `LocationModal_leftColumn__QopJO`,
	"rightColumn": `LocationModal_rightColumn__iV-SS`,
	"buttonDiv": `LocationModal_buttonDiv__q5pvq`,
	"uploadImageContainerClass": `LocationModal_uploadImageContainerClass__dc2Hh`,
	"uploadRow": `LocationModal_uploadRow__gWUGV`,
	"dropDownContainer": `LocationModal_dropDownContainer__IyPwt`,
	"myLabel": `LocationModal_myLabel__7REcE`,
	"sectionDivider": `LocationModal_sectionDivider__S4xOC`
};
export default ___CSS_LOADER_EXPORT___;
